export const selectRouterMatch = store => store.routerMatch
